import PropTypes from "prop-types";
import React from "react";
import Page from "../BaseComponents/Page/Page";
import {FaSolidIcon} from "../FontAwesomeIcons";
import ImpagatoCard from "./ImpagatoCard";

export default class ImpagatoModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <Page
                title={"Dettaglio pagamento"}
                leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                onLeftIconClick={this.props.onDismiss}
                active={true}
                content={
                    <div className={"p-2"}>
                        <ImpagatoCard
                            impagato={this.props.impagato}
                            defaultAdvancesOpen={true}
                        />
                    </div>
                }
            />
        )
    }
}

ImpagatoModal.propTypes = {
    impagato: PropTypes.object,
    onDismiss: PropTypes.func
}
